/**
 * Catálogo humano de los errores del sistema (rediseño /sistema): traduce el
 * mensaje técnico crudo a una etiqueta entendible por el dueño + un nivel.
 * PURO. Lo no catalogado cae a 'aviso' con el técnico en el detalle.
 * Mapeo definido en el diagnóstico del 2026-08-06 — mantenerlo al agregar
 * mensajes nuevos al sistema.
 */

export type NivelError = 'grave' | 'aviso' | 'ruido';

export const NIVEL_META: Record<NivelError, { emoji: string; label: string; orden: number }> = {
  grave: { emoji: '🔴', label: 'Grave', orden: 0 },
  aviso: { emoji: '🟡', label: 'Aviso', orden: 1 },
  ruido: { emoji: '⚪', label: 'Ruido', orden: 2 },
};

export interface HumanError {
  etiqueta: string;
  nivel: NivelError;
  /** false = no está en el catálogo (mostrar el técnico bien visible). */
  catalogado: boolean;
}

/** Regla del catálogo: si el mensaje CONTIENE el patrón (sin mayúsculas). */
interface Regla {
  patrones: string[];
  etiqueta: string;
  nivel: NivelError;
}

const CATALOGO: Regla[] = [
  {
    patrones: ['fallo al enviar respuesta del agente', 'fallo al enviar la respuesta del agente'],
    etiqueta: 'Un cliente se quedó sin respuesta del agente — revisar la conversación',
    nivel: 'grave',
  },
  {
    patrones: ['alerta del guardián sin entregar', 'reporte diario sin entregar'],
    etiqueta: 'El sistema intentó avisarte y no pudo (ni WhatsApp ni correo)',
    nivel: 'aviso',
  },
  {
    patrones: ['fallo al enviar el correo'],
    etiqueta: 'No salió un correo — revisar la configuración de correo',
    nivel: 'aviso',
  },
  {
    patrones: ['failed to decrypt message'],
    etiqueta: 'Llegó un mensaje de WhatsApp que no se pudo descifrar (pudo perderse)',
    nivel: 'aviso',
  },
  {
    patrones: ['stream errored out'],
    etiqueta: 'La conexión de WhatsApp se cortó — se reconecta sola',
    nivel: 'aviso',
  },
  {
    patrones: ["unexpected error in 'init queries'"],
    etiqueta: 'WhatsApp tardó en responder al reconectar — reintento automático',
    nivel: 'ruido',
  },
  {
    patrones: ["unexpected error in 'handling notification'"],
    etiqueta: 'Notificación interna de WhatsApp que no se pudo procesar',
    nivel: 'ruido',
  },
  {
    patrones: ['unhandledrejection capturado'],
    etiqueta: 'Error técnico interno atrapado — el sistema siguió funcionando',
    nivel: 'ruido',
  },
];

export function humanizeSystemError(message: string): HumanError {
  const m = message.toLowerCase();
  for (const regla of CATALOGO) {
    if (regla.patrones.some((p) => m.includes(p))) {
      return { etiqueta: regla.etiqueta, nivel: regla.nivel, catalogado: true };
    }
  }
  return { etiqueta: 'Error sin catalogar (ver detalle técnico)', nivel: 'aviso', catalogado: false };
}
